var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#BE1F3D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00003 18H12.5954V17.6878C12.0506 17.6878 11.0352 17.556 11.0352 15.6626V8.98393C11.0352 7.69091 11.2669 6.59766 11.7928 6.59766C11.7857 6.58888 11.9741 6.57134 12.785 6.57134C13.7986 6.57134 16.024 7.26046 16.1056 11C16.1709 13.9916 14.4402 15.1758 13.5667 15.3939L13.2765 18H18.5065V15.2082H18.2275C18.2275 15.8012 17.8369 16.2843 17.0997 16.2843H14.29L14.3296 15.8164C15.6629 15.8164 18.285 15 18.285 11C18.285 7 14.6183 6 12.785 6H5V6.29645C6.52974 6.29645 6.52239 7.78167 6.51978 8.30995C6.51968 8.33014 6.51959 8.34893 6.51959 8.36618V15.0042C6.51959 17.3964 6.02788 17.6484 5.00003 17.6484V18ZM8.79341 6.60107V17.5117C8.53579 17.5117 8.10608 16.7278 8.10608 15.7418V8.18896C8.10608 7.17138 8.53579 6.60107 8.79341 6.60107ZM8.79341 6.60107V17.5117C9.05104 17.5117 9.48083 16.7278 9.48083 15.7418V8.18896C9.48083 7.17138 9.05104 6.60107 8.79341 6.60107Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRome);
export default __webpack_public_path__ + "static/media/rome.be8667ff7678c639f0533ca062b4141b.svg";
export { ForwardRef as ReactComponent };